<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import PrivacyAuditListItem from './components/PrivacyAuditListItem';
import NewPrivacyAuditDialog from './components/NewPrivacyAuditDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'PrivacyAuditList',
  components: {
    PrivacyAuditListItem,
    NewPrivacyAuditDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Abgeschlossen', value: 'isFinished' }, { text: 'Bezeichnung', value: 'name' }, { text: 'Auditor', value: 'auditor' },
        { text: 'Beginn', value: 'startDate' }, { text: 'Ende', value: 'endDate' }, { text: 'Aktionen', value: '' }],
      showNewPrivacyAuditDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      privacyAuditToDelete: {},
      searchTerm: '',
    };
  },
  computed: {
    ...mapState(['privacyAuditList']),
    ...mapState('privacyAuditList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('privacyAuditList', { fetchData: 'fetchPrivacyAuditList' }),
    ...mapActions('privacyAuditDetails', ['deletePrivacyAudit']),
    onDelete(privacyAuditToDelete) {
      this.privacyAuditToDelete = privacyAuditToDelete;
      this.confirmDeletionMessage =
      `Soll das Audit ${this.privacyAuditToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deletePrivacyAudit(this.privacyAuditToDelete)
        .then(() => {
          this.fetchData();
          this.isConfirmDialogDisplayed = false;
        });
    },
    onSearch() {
      this.paginationParams.searchTerm = this.searchTerm;
      this.fetchData(this.paginationParams);
    },
  },
};
</script>

<template>
  <div class="privacyAudit-list">
    <template v-if="privacyAuditList.hasError">
      <p class="js-error-template ma-3">Failed to fetch privacyAudit list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewPrivacyAuditDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Neu</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-spacer />

        <v-flex md3 >
          <v-text-field
            v-model="searchTerm"
            label="Suche"
            height="22"
            class="caption"
            @keyup.enter="onSearch"
            @blur="onSearch"
          />
        </v-flex>
      </v-toolbar>

      <v-progress-linear
        v-if="privacyAuditList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="privacyAuditList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="privacyAuditList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable',
                       pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value, privacyAuditList.data)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <privacyAudit-list-item
            :privacy-audit="props.item"
            :expanded="props.expanded"
            @delete="onDelete"
          />
        </template>

        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewPrivacyAuditDialog
      v-if="showNewPrivacyAuditDialog"
      @cancel="showNewPrivacyAuditDialog = false"
    />

    <rbx-confirm-dialog
      @confirm="onConfirm" @refuse="onRefuse"
      :message="confirmDeletionMessage"
      :is-displayed="isConfirmDialogDisplayed"
    />
  </div>
</template>


<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
